module.exports = __webpack_public_path__ + "stylesheets/video-slider_f5ccdf0824648f1a5d99ec9741734968.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/video-slider.less
// module id = KApX
// module chunks = 151